import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

import { authApi } from "@/lib/api";
import { useAuthStore } from "@/lib/auth-store";

/**
 * Bug 2 (Batch 2 fixes): logout-hook die alle stappen netjes
 * uitvoert.
 *
 * Flow:
 *   1. POST /api/auth/logout met huidig refresh_token. Server roept
 *      auth_service.trek_refresh_token_in() aan: revoke in DB +
 *      audit_log entry 'logout'.
 *   2. Bij succes (of bij netwerk-fout — we willen lokaal in elk
 *      geval uitloggen) → useAuthStore.logoutLokaal(): wis access +
 *      refresh + pending-2FA tokens uit sessionStorage en zet store
 *      op anonymous.
 *   3. Navigate naar /login zodat ProtectedRoute niet kan klagen.
 *
 * Returnt { logout, bezig } voor gebruik in een knop.
 */
export function useLogout() {
  const navigate = useNavigate();
  const refreshToken = useAuthStore((s) => s.refreshToken);
  const logoutLokaal = useAuthStore((s) => s.logoutLokaal);
  const [bezig, setBezig] = useState(false);

  const logout = useCallback(async () => {
    setBezig(true);
    try {
      // Backend revoke + audit-log; we zijn defensief en negeren
      // netwerk-fouten zodat een offline-uitlog ook gewoon werkt.
      if (refreshToken) {
        await authApi.logout(refreshToken).catch(() => {
          /* offline-uitlog: server revoke later via expiry */
        });
      }
    } finally {
      logoutLokaal();
      setBezig(false);
      navigate("/login", { replace: true });
    }
  }, [refreshToken, logoutLokaal, navigate]);

  return { logout, bezig };
}
